var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6675 17.2778L19.7405 13.2046C19.879 13.0662 20.0531 12.9954 20.2627 12.9921C20.4722 12.9889 20.6495 13.0597 20.7945 13.2046C20.9393 13.3496 21.0117 13.5252 21.0117 13.7316C21.0117 13.9379 20.9393 14.1136 20.7945 14.2586L16.3002 18.7528C16.2066 18.8463 16.1078 18.9123 16.004 18.9508C15.9001 18.9893 15.788 19.0086 15.6675 19.0086C15.547 19.0086 15.4348 18.9893 15.331 18.9508C15.2271 18.9123 15.1284 18.8463 15.0347 18.7528L10.5405 14.2586C10.4021 14.1201 10.3313 13.946 10.328 13.7363C10.3248 13.5268 10.3956 13.3496 10.5405 13.2046C10.6855 13.0597 10.8611 12.9873 11.0675 12.9873C11.2738 12.9873 11.4495 13.0597 11.5945 13.2046L15.6675 17.2778Z",
    fill: "#101014"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevron);
export default __webpack_public_path__ + "static/media/chevron.a373aadc6d7a5b204ddfdaa12e8835b1.svg";
export { ForwardRef as ReactComponent };